import { locales } from '@monoimin/constants';

import type { Locales } from '@monoimin/sb-types';

export const getLocalePrefix = (locale: Locales) =>
  locale === 'en' ? '' : `/${locale}`;
export const getLocalePostfix = (locale: Locales) =>
  locale === 'en' ? '-en' : '';

export const createLocalizedPathname = (pathname: string, locale: Locales) => {
  const localePrefix = getLocalePrefix(locale);

  const localePostfix = getLocalePostfix(locale);

  return `${localePrefix}${pathname}${localePostfix}`;
};

export const getAlterLocales = <T = Locales>(
  excludingItem: T,
  allLocales?: T[]
) => {
  if (allLocales?.length) {
    return allLocales.filter((item) => item !== excludingItem) as T[];
  }
  return locales.filter((item) => item !== excludingItem) as T[];
};
